<template>
  <form @submit.prevent="onSubmit">
    <div
      class="members__search"
      :class="{'outlined': outlined}">
      <span class="material-icons members__search__icon">
        search
      </span>
      <input
        ref="memberInput"
        v-model="searchKeyword"
        type="search"
        class="form-control form-control--search"
        enterkeyhint="search"
        placeholder="名前で検索">
    </div>
  </form>
</template>

<script>
export default {
  props: {
    outlined: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchKeyword: ''
    }
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.searchKeyword)
      this.$refs.memberInput.blur()
    }
  }
}
</script>

<style lang="scss" scoped>
.members__search {
  position: relative;
  width: 50%;
  margin: 5px 0 15px auto;

  &.outlined {
    border: solid 1px $grey05;
    border-radius: 5px;
  }

  &__icon {
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
  }

  .form-control--search {
    height: 36px;
  }
}
</style>